import React from 'react';
import ReactDOM from 'react-dom/client';


import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./Redux/store";
import App from "./Components/App/Component/App";
import { storageGet } from "./Libs/Collector/StorageAction";
import { injectStore, getRefreshPageCheckToken } from "./Libs/Api/AxiosConfig"


if (process.env.REACT_APP_ENV === 'PROD') console.log = function () {};

injectStore(store);

let token = storageGet("token");
let refreshToken = storageGet("refreshToken")


if (typeof token !== "object" && token !== "" && typeof refreshToken !== "object" && refreshToken !== "") {
  getRefreshPageCheckToken();
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Provider store={store}>
      <App />
    </Provider>
  
);

reportWebVitals();
